import useDetailsBooking from 'hooks/useDetailsBooking';
import useTitleOnMount from 'hooks/useTitleOnMount';
import useSyncUrlWithStage from './hooks/useSyncUrlWithStage';
import ProcessingCancellation from './ProcessingCancellation';
import CancellationQuoteProvider, { useCancellationQuote } from './CancellationQuoteProvider';
import ReviewCancellation from './ReviewCancellation';
import ConfirmedCancellation from './ConfirmedCancellation';

const CancellationQuotePageContent = () => {
  const { booking } = useDetailsBooking();
  const { cancellationState } = useCancellationQuote();

  useTitleOnMount(`Cancelling ${booking.reference}`);
  useSyncUrlWithStage();

  switch (cancellationState) {
    case 'ACCEPTING':
      return <ProcessingCancellation />;
    case 'ACCEPTED':
      return <ConfirmedCancellation />;
    default:
      return <ReviewCancellation />;
  }
};

const CancellationQuotePage = () => (
  <CancellationQuoteProvider>
    <CancellationQuotePageContent />
  </CancellationQuoteProvider>
);

export default CancellationQuotePage;
